window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.main-menu').length) {
      import('./_main-menu.js').then((module) => {
      module.Init();
    });
  }
});

export default {};